import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { S25ObjectDetailsModule } from "../../../object-details/s25.object.details.module";
import { Item } from "../../../../pojo/Item";
import { OrganizationService } from "../../../../services/organization.service";
import { s25Resource } from "../../../../util/s25.resource";
import { S25ObjectDetailsService } from "../../../object-details/s25.object.details.service";
@Component({
    standalone: true,
    selector: "s25-ng-se-org-custom-attributes-widget",
    template: `
        @if (customAttrsResource.value()) {
            <s25-ng-object-details-custom-attr
                [customAttrs]="customAttrsResource.value()!"
                [itemId]="orgStore.orgId()!"
                [itemTypeId]="Item.Ids.Organization"
                [canEdit]="false"
                appearance="card"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [S25ObjectDetailsModule],
})
export class SeOrgCustomAttributesWidgetComponent extends LayoutWidget<typeof SeOrgCustomAttributesWidgetComponent> {
    static readonly META = {
        name: "Custom Attributes",
        info: "Displays organization custom attribute fields.",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);
    protected readonly Item = Item;

    protected readonly customAttrsResource = s25Resource({
        params: () => {
            const orgId = this.orgStore.orgId();
            if (!orgId) return undefined;
            return { orgId, version: this.orgStore.detailsVersion() };
        },
        loader: async ({ params: { orgId } }) => {
            const org = await OrganizationService.getOrganizationById(orgId, ["attributes"]);
            return S25ObjectDetailsService.formatOrgCustomAttrs(org?.custom_attribute);
        },
    });
}
